import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { selectSyncStatus, selectExportStartTime } from '../store/sync'
import { selectIsLoggedIn } from '../store/user'

const SyncStatusIndicatorComponent = ({ syncStatus, isLoggedIn, exportStartTime }) => {
    if (!isLoggedIn) return null

    const isUploadPending = () => !!exportStartTime && new Date().getTime() - exportStartTime > 2 * 1000

    const [uploadPending, setUploadPending] = useState(isUploadPending())
    useEffect(() => {
        const timer = setInterval(() => {
            setUploadPending(isUploadPending())
        }, 100)

        return () => clearInterval(timer)
    })

    let description, faSymbol
    if (syncStatus.saved) {
        if (!syncStatus.newChangesOnServer) {
            return null
        } else {
            description = 'Loading...'
            faSymbol = 'cloud-download'
        }
    } else {
        if (syncStatus.newChangesOnServer) {
            description = 'Conflict'
            faSymbol = 'exclamation-circle'
        } else {
            if (!uploadPending) return null
            description = 'Saving...'
            faSymbol = 'cloud-upload'
        }
    }
    // offline: fa-caravan

    return (
        <>
            <i className={`fal fa-${faSymbol}`}></i>
            <span className="titleview-icon-description">{description}</span>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        syncStatus: selectSyncStatus(state),
        isLoggedIn: selectIsLoggedIn(state),
        exportStartTime: selectExportStartTime(state)
    }
}

export const SyncStatusIndicator = connect(mapStateToProps)(SyncStatusIndicatorComponent)
